import { render, staticRenderFns } from "./ASorItemList.vue?vue&type=template&id=4cdfaa4e"
import script from "./ASorItemList.vue?vue&type=script&lang=js"
export * from "./ASorItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports